/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import Canvas from "../../useful/Canvas"
import { ICardFieldProps } from "../cards/CardField"
import { CardFiled, ILandingCanvas, OVERFLOW_TYPE } from "src/modules/pe-landing-module/data/interfaces"

const CardFieldChanvas = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    const getField = (field: CardFiled): any => {
        let f:any = {...field} 
        delete f.id
        delete f.background
        delete f.style
        delete f.className
        
        // console.log(f, field)
        
        return f
    }
    useEffect(() => { 
            addCSSClass(
                `landing-card-field-canvas-${section.id + "-" + value?.id}`,
                `.landing-card-field-canvas-${section.id + "-" + value?.id} {
                    
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-canvas-${section.id + "-" + value?.id}`)
        }, [])
        
    const getCanvas = (): any | ILandingCanvas => {
        return {
            id: section.id + "_" + value?.id,
            type: field.type,
            overflow: OVERFLOW_TYPE.HIDDEN,
            data: {
                fields: getField(field).data,
                values: value?.data,
            },
            floats: [],
            length:1,
            composition: {},
            height: field.height || value.style?.height,
            background : { ...field.background, ...value?.data?.background }, 
        } as any
    }
    const _section = getCanvas()
    
    return <div 
        className={`landing-card-field landing-card-field-canvas landing-card-field-canvas-${section.id + "-" + value.id} ${value.className}`}  
        style={{ ...field.style, ...value.style }}
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        <Canvas section={ _section } />
    </div>
}
export default CardFieldChanvas